(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[266],{

/***/ 3427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Sections; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);


const DynamicImage = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 673).then(__webpack_require__.bind(__webpack_require__, 9673)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9673)
            ]
    },
    suspense: false
});
const DynamicTeaserText = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 531).then(__webpack_require__.bind(__webpack_require__, 4531)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(4531)
            ]
    },
    suspense: false
});
const DynamicRichText = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 639).then(__webpack_require__.bind(__webpack_require__, 2639)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(2639)
            ]
    },
    suspense: false
});
const DynamicVideo = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 533).then(__webpack_require__.bind(__webpack_require__, 6533)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(6533)
            ]
    },
    suspense: false
});
const DynamicCards = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 710).then(__webpack_require__.bind(__webpack_require__, 1710)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(1710)
            ]
    },
    suspense: false
});
const DynamicHero = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 715).then(__webpack_require__.bind(__webpack_require__, 5715)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(5715)
            ]
    },
    suspense: false
});
const DynamicQuote = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 956).then(__webpack_require__.bind(__webpack_require__, 1956)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(1956)
            ]
    },
    suspense: false
});
const DynamicContact = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(964), __webpack_require__.e(665)]).then(__webpack_require__.bind(__webpack_require__, 6665)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(6665)
            ]
    },
    suspense: false
});
const DynamicTitleParagraphLinks = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 913).then(__webpack_require__.bind(__webpack_require__, 6913)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(6913)
            ]
    },
    suspense: false
});
const DynamicTeam = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 302).then(__webpack_require__.bind(__webpack_require__, 7302)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(7302)
            ]
    },
    suspense: false
});
const DynamicPageTitle = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 810).then(__webpack_require__.bind(__webpack_require__, 3810)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(3810)
            ]
    },
    suspense: false
});
const DynamicEvents = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 508).then(__webpack_require__.bind(__webpack_require__, 9508)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9508)
            ]
    },
    suspense: false
});
const DynamicButton = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 204).then(__webpack_require__.bind(__webpack_require__, 9204)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9204)
            ]
    },
    suspense: false
});
const DynamicVimeo = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 76).then(__webpack_require__.bind(__webpack_require__, 5076)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(5076)
            ]
    },
    suspense: false
});
const DynamicHighlight = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 131).then(__webpack_require__.bind(__webpack_require__, 6131)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(6131)
            ]
    },
    suspense: false
});
const DynamicHTML = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 66).then(__webpack_require__.bind(__webpack_require__, 3066)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(3066)
            ]
    },
    suspense: false
});
const DynamicVideoCarousel = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 683).then(__webpack_require__.bind(__webpack_require__, 8683)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(8683)
            ]
    },
    suspense: false
});
const DynamicWhistleblowerForm = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(964), __webpack_require__.e(990)]).then(__webpack_require__.bind(__webpack_require__, 2990)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(2990)
            ]
    },
    suspense: false
});
const sectionComponents = {
    ComponentSectionsImage: DynamicImage,
    ComponentSectionsImageText: DynamicTeaserText,
    ComponentSectionsRichText: DynamicRichText,
    ComponentSectionsVideo: DynamicVideo,
    ComponentSectionsCards: DynamicCards,
    ComponentSectionsHero: DynamicHero,
    ComponentSectionsQuote: DynamicQuote,
    ComponentSectionsTitleParagraphLinks: DynamicTitleParagraphLinks,
    ComponentSectionsTeam: DynamicTeam,
    ComponentSectionsPageTitle: DynamicPageTitle,
    ComponentSectionsEvents: DynamicEvents,
    ComponentSectionsContact: DynamicContact,
    ComponentSectionsButton: DynamicButton,
    ComponentSectionsVideoText: DynamicTeaserText,
    ComponentSectionsHeroVideo: DynamicHero,
    ComponentSectionsVimeo: DynamicVimeo,
    ComponentSectionsHighlight: DynamicHighlight,
    ComponentSectionsHtml: DynamicHTML,
    ComponentSectionsVideoCarousel: DynamicVideoCarousel,
    ComponentSectionsWhistleblowerForm: DynamicWhistleblowerForm
};
const Section = (param)=>{
    let { section , settings  } = param;
    const SectionComponent = sectionComponents[section.sectionName];
    if (!SectionComponent) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionComponent, {
        data: section,
        settings: settings
    });
};
function Sections(param) {
    let { sections , settings  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: sections.map((section, index)=>{
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Section, {
                section: section,
                settings: settings
            }, index);
        })
    });
}


/***/ }),

/***/ 4169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ Seo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _lib_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4327);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



function Seo(param) {
    let { title , seo , url  } = param;
    var _facebookData_image, _twitterData_image;
    const { metaDescription , metaTitle , metaImageUrl , metaRobots , structuredData , canonicalURL , keywords , metaSocial  } = seo !== null && seo !== void 0 ? seo : {
        metaTitle: title,
        metaDescription: title,
        metaImageUrl: (0,_lib_image__WEBPACK_IMPORTED_MODULE_1__/* .buildImageUrl */ .Sc)("/logo.svg"),
        metaSocial: []
    };
    const facebookData = metaSocial.find((meta)=>meta.socialNetwork == "Facebook");
    const twitterData = metaSocial.find((meta)=>meta.socialNetwork == "Twitter");
    var _facebookData_title, _facebookData_description, _facebookData_image_url, _twitterData_title, _twitterData_description, _twitterData_image_url;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: metaTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: metaTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: metaDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: (_facebookData_title = facebookData === null || facebookData === void 0 ? void 0 : facebookData.title) !== null && _facebookData_title !== void 0 ? _facebookData_title : metaTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: (_facebookData_description = facebookData === null || facebookData === void 0 ? void 0 : facebookData.description) !== null && _facebookData_description !== void 0 ? _facebookData_description : metaDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: (0,_lib_image__WEBPACK_IMPORTED_MODULE_1__/* .buildImageUrl */ .Sc)((_facebookData_image_url = facebookData === null || facebookData === void 0 ? void 0 : (_facebookData_image = facebookData.image) === null || _facebookData_image === void 0 ? void 0 : _facebookData_image.url) !== null && _facebookData_image_url !== void 0 ? _facebookData_image_url : metaImageUrl)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:title",
                content: (_twitterData_title = twitterData === null || twitterData === void 0 ? void 0 : twitterData.title) !== null && _twitterData_title !== void 0 ? _twitterData_title : metaTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:description",
                content: (_twitterData_description = twitterData === null || twitterData === void 0 ? void 0 : twitterData.description) !== null && _twitterData_description !== void 0 ? _twitterData_description : metaDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:image",
                content: (0,_lib_image__WEBPACK_IMPORTED_MODULE_1__/* .buildImageUrl */ .Sc)((_twitterData_image_url = twitterData === null || twitterData === void 0 ? void 0 : (_twitterData_image = twitterData.image) === null || _twitterData_image === void 0 ? void 0 : _twitterData_image.url) !== null && _twitterData_image_url !== void 0 ? _twitterData_image_url : metaImageUrl)
            }),
            metaRobots && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: metaRobots
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "googlebot",
                        content: metaRobots
                    })
                ]
            }),
            structuredData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: structuredData
                    }
                }, "structured-data")
            }),
            keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            canonicalURL && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalURL
            })
        ]
    });
}


/***/ }),

/***/ 7645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var _loadable = _interop_require_default(__webpack_require__(4588));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: (param)=>{
            let { error , isLoading , pastDelay  } = param;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 3644:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 4588:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(1598)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(7294));
var _loadableContext = __webpack_require__(3644);
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = (0, _react).useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    let ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(7645)


/***/ })

}]);